import React from 'react';
import LoginContainer from './login.container';
import './loginPage.css';

const LoginPage = () => (
  <div>
    <LoginContainer />
  </div>
)

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/login/loginPage.js